import { useCallback, useEffect, useRef, useState } from "react";

export default function useToast() {
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);

  const hideToast = useCallback(() => {
    clearTimeout(timer.current);
    setShowToast(false);
    setToastMessage("");
  }, []);

  const showToastNotification = useCallback((message, duration = 3000) => {
    clearTimeout(timer.current);
    setToastMessage(message);
    setShowToast(true);
    timer.current = setTimeout(hideToast, duration);
  }, [hideToast]);

  return { showToast, toastMessage, showToastNotification, hideToast };
}
